<template>
  <ul class="chats-list" :class="[size ? 'chats-list--' + size : '', !isOpen ? 'chats-list--hidden' : '']">
    <li
      class="chats-list__item"
      :class="{'active' : show === index}"
      v-for="(chat, index) in chatsForRender"
      :key="chat.id"
      @mouseenter="show = index"
      @mouseout="show = false"
    >
      <a
        :ref="chat.name"
        class="chats-list__link"
        :style="{ 'background-image': `url(${chat.icon})`, 'background-color': chat.background }"
        target="_blank"
        :href="chat.link"
        @click="openChat"
      >
        <Loader v-if="chat.id === 1" :is-loading="isZendeskLoading" :border-size="2"/>
      </a>
      <span class="chats-list__label">{{ $t(chat.label) }}</span>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import Loader from '../helpers/Loader'
import detectMobileDevices from '../../helpers/detectMobileDevices'

export default {
  name: 'ChatsList',
  components: { Loader },
  computed: {
    ...mapState({
      chats: state => state.chats.chats,
      isOpen: state => state.chats.isOpen,
      user: state => state.user,
      language: state => state.translation.language
    }),
    chatsForRender () {
      const chatsForRender = []

      this.chats.forEach(chat => {
        if (detectMobileDevices.any()) {
          chatsForRender.push(chat)
        } else {
          if (chat.name !== 'phone') chatsForRender.push(chat)
        }
      })

      return chatsForRender
    }
  },
  data () {
    return {
      show: false,
      isZendeskLoading: false,
      isOpenChat: false
    }
  },
  props: {
    size: {
      type: String,
      default: 'large'
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openChat (e) {
      const { target } = e
      const chat = this.$refs.chat[0]
      if (target.className === 'loader') {
        e.preventDefault()
      }
      if (target === chat) {
        e.preventDefault()

        if (localStorage.getItem('zDChatStatus') === 'loaded' && this.$zendesk.isZe()) {
          this.$zendesk.open()
        } else {
          this.isZendeskLoading = true
          this.initChat()
        }
      }
    },
    initChat (open = true) {
      this.$zendesk.load(process.env.VUE_APP_ZENDESK_KEY)
      this.isOpenChat = open
      if (localStorage.getItem('zDChatStatus') !== 'loaded') {
        let ttl = new Date()
        ttl.setHours(ttl.getHours() + 1)

        localStorage.setItem('zDChatStatusExpire', ttl.getTime())
        localStorage.setItem('zDChatStatus', 'loaded')
      }
    }
  },
  mounted () {
    const now = new Date()
    if (localStorage.getItem('zDChatStatusExpire') && localStorage.getItem('zDChatStatusExpire') < now.getTime()) {
      localStorage.removeItem('zDChatStatus')
      localStorage.removeItem('zDChatStatusExpire')
    }
    // Время через которое начнет инициализироваться чат Zendesk
    let timeOutChatLoading = 0
    // if (localStorage.getItem('zDChatStatus') === 'loaded') {
    //   timeOutChatLoading = 3000
    // } else {
    //   timeOutChatLoading = 20000
    // }
    setTimeout(() => {
      this.initChat(false)
    }, timeOutChatLoading)
  },
  created () {
    this.$zendesk.$on('loaded', () => {
      if (this.user && this.user.auth && this.user.user_data) {
        this.$zendesk.identify({
          name: (!this.user.user_data.name && !this.user.user_data.last_name) ? '' : this.user.user_data.name + ' ' + this.user.user_data.last_name,
          email: (this.user.user_data.email) ? this.user.user_data.email : '',
          phone: (this.user.user_data.phone) ? this.user.user_data.phone : ''
        })
      }

      this.$zendesk.setLocale(this.language)

      // if (this.isOpen) {
      //   this.$zendesk.open()
      //   // eslint-disable-next-line no-return-assign
      //   setTimeout(() => this.isZendeskLoading = false, 1000)
      // }
    })
  }
}
</script>

<style lang="sass">

.chats-list
  +list-unstyled
  display: flex
  flex-flow: column-reverse
  position: absolute
  left: 0
  right: 0
  margin: auto
  transition: .4s

  &--small
    width: 40px
    bottom: 20px

    +mmin($tablet--hor)
      width: 60px
      bottom: 36px

    .chats-list__item
      width: 40px
      height: 40px

      +mmin($tablet--hor)
        width: 60px
        height: 60px

  &--medium
    width: 50px
    bottom: 100px

    .chats-list__item
      width: 40px
      height: 40px

  &--large
    width: 60px
    bottom: 120px

    .chats-list__item
      width: 50px
      height: 50px

  &--hidden
    bottom: 0
    opacity: 0
    visibility: hidden

.chats-list__label
  display: none
  position: absolute
  font-size: 14px
  right: calc(100% + 20px)
  top: 50%
  transform: translateY(-50%)
  padding: 3px 11px
  background: $white-text-color
  border-radius: 10px

@keyframes animate
  0%
    transform: scale(0.4)
    opacity: 0
  15%
    opacity: 1
  30%
    transform: scale(0.8)
    opacity: 0
  100%
    transform: scale(0.6)
    opacity: 0
.chats-list__item
  position: relative
  display: block
  margin: 0 auto
  border-radius: 50%
  box-shadow: 0 0 3px rgba(0,0,0,.2)
  cursor: pointer

  &:before,
  &:after
    content: ''
    display: block
    position: absolute
    border-radius: 50%
    border: 1px solid #ff2f00
    left: -20px
    right: -20px
    top: -20px
    bottom: -20px
    animation: animate 3s linear infinite
    animation-delay: 2s
    opacity: 0
    backface-visibility: hidden
    pointer-events: none

  &:after
    animation-delay: 2.2s

  &:not(:first-child)
    margin-bottom: 10px

.chats-list__link
  display: block
  width: 100%
  height: 100%
  border-radius: 50%
  background-position: center
  background-repeat: no-repeat
  background-size: 50%
  outline: none
  position: relative

.chats-list__item.active
  .chats-list__label
    display: block

#launcher
  display: none !important
</style>
